import { useDroppable } from '@dnd-kit/core';

export const DroppableArea = ({
    id,
    children,
    className = ''
}: {
    id: string;
    children: React.ReactNode;
    className?: string;
}) => {
    const { setNodeRef, isOver } = useDroppable({ id });

    return (
        <div
            ref={setNodeRef}
            className={className}
            style={{
                minHeight: 200,
                border: '2px dashed lightgray',
                backgroundColor: isOver ? '#f0f0f0' : undefined,
                padding: 12,
                transition: 'background-color 0.2s',
                overflow: 'visible'
            }}
        >
            {children}
        </div>
    );
};
